// Simple check
export function areRegexEqual(r1: RegExp, r2: RegExp): boolean {
  if (!r1 || !r2) {
    return false;
  }

  return r1.toString() === r2.toString();
}
